/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyEmail
 */
export interface VerifyEmail {
    /**
     * 
     * @type {string}
     * @memberof VerifyEmail
     */
    key: string;
}

/**
 * Check if a given object implements the VerifyEmail interface.
 */
export function instanceOfVerifyEmail(value: object): value is VerifyEmail {
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function VerifyEmailFromJSON(json: any): VerifyEmail {
    return VerifyEmailFromJSONTyped(json, false);
}

export function VerifyEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyEmail {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
    };
}

  export function VerifyEmailToJSON(json: any): VerifyEmail {
      return VerifyEmailToJSONTyped(json, false);
  }

  export function VerifyEmailToJSONTyped(value?: VerifyEmail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
    };
}

